// extracted by mini-css-extract-plugin
export default {"container":"helpTooltip_container__MliXo","align-top":"helpTooltip_align-top__hPmnG"};